import Config from './Config';
import loadGoogleMapsAPI from 'load-google-maps-api'

export default class Homepage {
    constructor(props) {
        this.mapSelector = 'contactMap'
        this.initLayout();
        this.loadGoogleMaps();
    }

    initLayout() {
        $('.contact-columns').matchHeight({

        });
    }

    loadGoogleMaps(){
         loadGoogleMapsAPI({
            language: $('#' + this.mapSelector).data('lang') || 'en',
            key: Config.getGoogleMapsApiKey()
         }).then((googleMaps) => {
            this.maps = googleMaps;
            this.initMap();
        }).catch((err) => {
            console.error(err)
        })
    }
    initMap(){
        this.map = new this.maps.Map(document.getElementById(this.mapSelector), {
          zoom: 12,
          center: this.getMapLocation(),
          disableDefaultUI: true
        });

        var marker = new this.maps.Marker({
            position: this.getMapLocation(),
            map: this.map,
            icon: $('#' + this.mapSelector).data('marker-icon')
        });

        setTimeout(() => {
            Config.removePageLoader();
        }, 500)
    }

    getMapLocation(){
        return {
            lng: $('#' + this.mapSelector).data('lng') || 34.7699902,
            lat: $('#' + this.mapSelector).data('lat') || 32.0177322
        };
    }
}



// WEBPACK FOOTER //
// src/scripts/ContactPage.js